import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface BillingPaywallState {
  clubId: string | null
}

const initialState: BillingPaywallState = {
  clubId: null,
}

export const billingPaywallSlice = createSlice({
  name: 'billingPaywall',
  initialState,
  reducers: {
    showPaywall: (state, action: PayloadAction<string>) => {
      state.clubId = action.payload
    },
    clearPaywall: (state) => {
      state.clubId = null
    },
  },
})

export const { showPaywall, clearPaywall } = billingPaywallSlice.actions
export default billingPaywallSlice.reducer
